import { createContext } from 'react';

const MerchantContext = createContext(null as any);
export default MerchantContext;
